export default __webpack_public_path__ + "static/media/aws-rds.9a139143.svg";